/**
 * Olfacy tabs: accessible tabs whose inactive panels are stored in <template>s.
 * A panel is hydrated (cloned into the page) the first time its tab is opened, so hidden
 * tabs cost no image downloads or layout until needed. Switching afterwards is instant.
 */
class OlfacyTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    this.viewAll = this.querySelector('[data-view-all]');
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (event) => this.onKey(event, i));
    });
  }

  onKey(event, i) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i === last ? 0 : i + 1;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i === 0 ? last : i - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = this.panels[i];
      if (!panel) return;
      if (active) {
        const template = panel.querySelector(':scope > template');
        if (template) {
          panel.append(template.content.cloneNode(true));
          template.remove();
        }
      }
      panel.hidden = !active;
    });

    const tab = this.tabs[index];
    if (this.viewAll && tab.dataset.url) this.viewAll.href = tab.dataset.url;
    // Keep the active tab visible when the tab bar scrolls on mobile
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
}

if (!customElements.get('olfacy-tabs')) {
  customElements.define('olfacy-tabs', OlfacyTabs);
}
